import React from "react";
import { Tooltip, Box } from "@mui/material";

const TruncatedText = ({ text, maxLength = 200 }) => {
  return (
    <Tooltip title={text.length > maxLength ? text : ""}>
      <Box
        component="span"
        sx={{
          display: "inline-block",
          maxWidth: `${maxLength}ch`,
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
        }}
      >
        {text}
      </Box>
    </Tooltip>
  );
};

export default TruncatedText;
